export enum AppStoreType {
  GOOGLE_PLAY_STORE = 'GOOGLE_PLAY_STORE',
  APPLE_APP_STORE = 'APPLE_APP_STORE',
}
